<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="booking-container">
                <div v-if="isLoading" class="d-flex justify-content-center">
                    <loader></loader>
                </div>
                <div v-else>
                    <div class="row d-flex justify-content-center mb-4">
                        <div class="col-12 text-center ">
                            <h2 v-if="restaurants.length > 1" class="mb-4">Choose your dining experience</h2>
                            <h2 v-else class="mb-4">Choose your dining time</h2>
                        </div>
                    </div>


                    <div v-if="restaurants.length > 1" class="mb-4">
                        <div class="row d-flex mb-4">
                            <div class="col-24 d-flex justify-content-center">
                                <div class="text-center" v-for="(r, ri) in restaurants">
                                    <button class="btn btn--slate-white modal-button mx-2"
                                            v-bind:class="{'modal-button--active': activeRestaurant == r}"
                                            v-on:click="onSetRestaurant(r)">
                                        {{r.DisplayName}}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="row d-flex justify-content-center mb-6">
                            <div class="col-12 text-center ">

                                <h2 class="mb-4">{{activeRestaurant?.DisplayName}} </h2>
                            </div>
                        </div>
                    </div>


                    <div v-if="activeRestaurant">
                        <div v-if="timesLoading">
                            <loader></loader>
                        </div>
                        <div v-else>
                            <div class="row justify-content-center" v-if="activeRestaurant?.availability != null && activeRestaurant.availability.length">
                                <div class="col-12">
                                    <div class="row justify-content-center">
                                        <div v-for="(arrivalTime, tImedex) in activeRestaurant.availability"
                                             class="col-24  mb-2">
                                            <button class="btn btn--block time-slot "
                                                    v-on:click="onSelectArrivalTime(arrivalTime)"
                                                    v-bind:class="{'time-slot--active': isSelected(arrivalTime), 'timeslot--disabled' : isDisabled()}">
                                                {{formatTime(arrivalTime.TimeSlot)}}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else>

                                <div class="row justify-content-center">
                                    <div class="col-18 d-flex justify-content-center">
                                        <info-box v-bind:type="'error'">

                                            <template v-slot:body>
                                                <strong>Sorry, we have no availability for {{activeRestaurant?.DisplayName}}</strong>

                                            </template>
                                        </info-box>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="restaurants.length > 1 && activeRestaurant == null">
                        <div class="row  justify-content-center">
                            <div class="col-18 d-flex justify-content-center">
                                <info-box v-bind:type="'alert'">
                                    <template v-slot:body>
                                        <strong>
                                            Please select a restaurant.
                                        </strong>

                                    </template>
                                </info-box>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <actions-bar>
            <template v-slot:actions>
                <div class="row">
                    <div class="col-10">

                        <button v-on:click="onBack"
                                type="button"
                                class="btn btn--transparent btn--back">
                            Back
                        </button>
                    </div>

                    <div class="col-4 d-flex flex-column align-items-center">

                        <span v-if="total > 0" class="spa-total-label">Total</span>
                        <span v-if="total > 0" class="spa-total">&pound;{{total}}</span>

                    </div>

                    <div class="col-10 d-flex justify-content-end">
                        <button class="btn btn--slate-blue btn--continue"
                                v-bind:disabled="!canContinue()"
                                type="button"
                                v-on:click="onContinue()">
                            Next

                        </button>
                    </div>
                </div>
            </template>
        </actions-bar>


    </div>
</template>

<script>
    import ActionsBar from '@/shared/components/ActionsBar.vue';
    import Loader from '@/shared/components/Loader.vue';
    import { store } from '../store/index';
    import InfoBox from '@/shared/components/InfoBox.vue';

    import restaurantapi from '@/shared/api/restaurant';

    export default {
        name: 'SpaDayDiningTme',

        components: {

            ActionsBar,
            Loader,
            InfoBox

        },

        mounted() {

            this.isLoading = true;

            this.restaurants = this.search.spaDay.Restaurants;

            if (this.restaurants.length == 1) {
                this.onSetRestaurant(this.restaurants[0]);

            }

            this.isLoading = false;
        },
        data() {
            return {
                isLoading: false,
                restaurants: [],
                selectedTime: null,
                activeRestaurant: null,
                timesLoading: false

            }
        },
        computed: {
            session() {
                return store.getters.session
            },
            search() {
                return store.getters.search;
            },
            booking() {
                return store.getters.booking;
            },
            total() {
                return store.getters.dayTotal
            },
            facilities() {
                return store.getters.facilities;
            },
            restaurantFacilities() {
                var facilityKey = this.activeRestaurant.SpaFacilityName;
                let restaurantFacilities = this.facilities.find(item => item.key == facilityKey);
                return restaurantFacilities;
            }
        },
        methods: {

            onSetRestaurant(restaurant) {
                let o = this;
                o.selectedTime = null;
                o.activeRestaurant = restaurant;
                o.timesLoading = true;
     
                if (restaurant.availabilty == null) {


                    let repayload = {
                        Guests: this.search.guests.length,
                        ArrivalDate: moment(this.search.date).format('YYYY-MM-DD'),
                        NumberOfNights: 1,
                        Restaurants: [restaurant.RestaurantId],
                        Sitting: restaurant.Sitting,
                        StartTime: restaurant.DiningStartTime,
                        EndTime: restaurant.DiningEndTime
                    }

                   

                    restaurantapi.getAvailability(repayload, t => {
                        let availabilty = [];
                        if (t != null && t.length) {
                            let timeSlots = t[0]?.RestaurantAvailabilities[0]?.Availability?.TimeSlots;
                        
                            let facilities = o.restaurantFacilities?.items.filter(item => item.items.length >= o.search.guests.length);
                            
                            if (facilities && timeSlots.length) {
                                for (let i = 0; i < timeSlots.length; i++) {
                                    let timeSlot = timeSlots[i];

                                    let facility = facilities.find(item => item.key == timeSlot.TimeSlot);
                                    if (facility?.items != null && facility.items.length >= o.search.guests.length) {

                                        let timeSlotFacilityItems = facility.items.slice(0, o.search.guests.length);

                                        timeSlot.Facilities = timeSlotFacilityItems;



                                        availabilty.push(timeSlot);
                                    }

                                    o.activeRestaurant.availability = availabilty;
                                }
                            }
                         

                    

                            o.timesLoading = false;
                        }
                    });
                }
                else {
                    o.timesLoading = false;
                }

            },

            onContinue() {
                let payload = {
                    displayName: this.activeRestaurant.DisplayName,
                    spaCode: this.activeRestaurant.SpaCode,
                    spaFacility: this.activeRestaurant.SpaFacilityName,
                    restaurantId: this.activeRestaurant.RestaurantId,
                    serviceStartTime: this.activeRestaurant.DiningStartTime,
                    serviceEndTime: this.activeRestaurant.DiningEndTime,
                    selectedTime: this.selectedTime,
                    duration: this.activeRestaurant.DurationInMins
                };

                store.dispatch("setRestaurantTimes", payload).then(() => {

                    if (this.search.spaDay.HasSpaGarden) {
                        this.$router.push({ name: 'spa_day_garden', params: { id: this.session.Id } });
                    }
                    else if (this.search.spaDay.HasTreatments) {
                        this.$router.push({ name: 'spa_day_treatments', params: { id: this.session.Id } });
                    }
                    else if (this.search.spaDay.HasExtras) {
                        this.$router.push({ name: 'spa_day_add_ons', params: { id: this.session.Id } });
                    }
                    else {
                        this.$router.push({ name: 'spa_day_details', params: { id: this.session.Id } });
                    }
                });
            },
            onBack() {
                this.$router.push({ name: 'spa_day_arrival_time', params: { id: this.session.Id } });
              
            },
            onSelectArrivalTime(input) {
                this.selectedTime = input;
            },
            isSelected(input) {
                return this.selectedTime == input;
            },
            isDisabled() {
                return false;
            },
            canContinue() {
                return this.activeRestaurant != null && this.selectedTime != null;
            },
            formatTime(input) {
                return moment(input).format("HH:mm");
            }
        }

    }
</script>

<style scoped>

    .modal-button {
        background-color: #fff;
        position: relative;
        color: #000;
        border-color: #fff;
        margin-bottom: 30px !important;
    }


        .modal-button:after {
            border-top: 10px solid #fff;
            display: block;
            position: absolute;
            content: ' ';
            bottom: -11px;
            left: 50%;
            transform: translateX(-50%);
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            z-index: 10;
        }



    .modal-botton:hover,
    .modal-button--active {
        background-color: #425260;
        border-color: #425260;
        color: #fff;
    }

        .modal-botton:hover,
        .modal-button--active:after {
            border-top: 10px solid #425260;
        }

    .time-slot {
        background: white;
        border-radius: 5px;
        margin-bottom: 20px;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 20px;
        cursor: pointer !important;
        border: none;
    }


        .time-slot.time-slot--unavailable {
            color: rgba(66, 82, 96, 0.15);
            cursor: not-allowed;
        }


        .time-slot:not(.time-slot--unavailable):hover,
        .time-slot.time-slot--active {
            background-color: #425260;
            color: #fff;
        }

    .spa .spa-total-label {
        font-weight: 300;
        display: block;
        font-size: 16px;
        text-align: center;
        text-transform: uppercase;
    }

    .spa .spa-total {
        font-weight: bold;
        display: block;
        font-size: 24px;
        text-align: center;
    }

    .stacked-option {
        width: 20px;
        height: 20px;
        top: 3px;
        position: relative;
        margin-right: 5px;
    }

    .same-time {
        cursor: pointer !important;
    }
</style>